import Path from "../../services/paths";
import DemandPlannerActions from "../actions/demandPlannerActions";
import utils from "../common/utils";
import axios from "axios";

class DemandPlannerMiddleware {
  static getDemandPlanner(
    page,
    selectedCategory,
    selectedBrand,
    selectedSku,
    selectedYear,
    weekFrom,
    weekTo,
    selectedForecast,
    selectedWeekFrom,
    selectedCOTC
  ) {
    // console.log("IS VALUEEEEE", weekFrom);
    let url = `${Path.GET_DEMAND_PLANNER}?`;
    if (page) {
      url += `page=${page}&`;
    }
    if (selectedCategory) {
      url += `category=${selectedCategory}&`;
  }
    if (Array.isArray(selectedBrand)) {
      selectedBrand.forEach(element => {
        url += `brand=${element}&`;
      });
    }
    if (Array.isArray(selectedSku)) {
      selectedSku.forEach(element => {
        url += `master_sku=${element}&`;
      });
    }
    if (selectedCOTC) {
      url += `cotc=${selectedCOTC}&`;
  }
    if (selectedYear) {
      
        url += `year=${selectedYear}&`;
      
    }
    if (weekFrom) {
      url += `duration_from=${weekFrom}&`;
    }
    if (weekTo) {
      url += `duration_to=${weekTo}&`;
    }
    if (selectedWeekFrom) {
      url += `snapshot=${selectedWeekFrom}&`;
    }
    // if (forecasted) {
    //   url += `forecasted=${forecasted}&`;
    // }
    // if (Array.isArray(selectedDemandDriver)) {
    //   selectedDemandDriver.forEach(element => {
    //     url += `demmand_driver_type=${element}&`;
    //   });
    // }
    if (selectedForecast===false) {
      url += `forecasted=${selectedForecast}&`;
    } else {
      url += `forecasted=true&`;
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(DemandPlannerActions.demandPlannerRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.error) {
                // console.log("ERROR", res.error);
              } else {
                // console.log("SUCCESS", res);
                dispatch(DemandPlannerActions.demandPlannerSuccessul(res));
              }
            })
            .catch(error => {
              // console.log("IN CATCH");
              dispatch(DemandPlannerActions.demandPlannerFailed(error));
            });
        })
        .catch(error => {
          // console.log("IN CATCH");
          dispatch(DemandPlannerActions.demandPlannerFailed(error));
        });
    };
  }

  static getDemandPlannerSecMat(
    selectedCategory,
    selectedBrand,
    selectedSku,
  ) {
    // console.log("IS VALUEEEEE", weekFrom);
    let url = `${Path.GET_DEMAND_PLANNER_SEC_MAT}?`;

    if (selectedCategory) {
        url += `category=${selectedCategory}&`;
    }
    if (Array.isArray(selectedBrand)) {
      selectedBrand.forEach(element => {
        url += `brand=${element}&`;
      });
    }
    if (Array.isArray(selectedSku)) {
      selectedSku.forEach(element => {
        url += `master_sku=${element}&`;
      });
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(DemandPlannerActions.demandPlannerSecMatRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.error) {
                // console.log("ERROR", res.error);
              } else {
                // console.log("SUCCESS", res);
                dispatch(DemandPlannerActions.demandPlannerSecMatSuccessul(res));
              }
            })
            .catch(error => {
              // console.log("IN CATCH");
              dispatch(DemandPlannerActions.demandPlannerSecMatFailed(error));
            });
        })
        .catch(error => {
          // console.log("IN CATCH");
          dispatch(DemandPlannerActions.demandPlannerSecMatFailed(error));
        });
    };
  }

  static getDemandPlannerSecMatSaleMsku(
    selectedSku,
  ) {
    // console.log("IS VALUEEEEE", weekFrom);
    let url = `${Path.GET_DEMAND_PLANNER_SEC_MAT_SALE_MSKU}?`;

    if (Array.isArray(selectedSku)) {
      selectedSku.forEach(element => {
        url += `master_sku=${element}&`;
      });
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(DemandPlannerActions.demandPlannerSecMatSaleMskuRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.error) {
                // console.log("ERROR", res.error);
              } else {
                // console.log("SUCCESS", res);
                dispatch(DemandPlannerActions.demandPlannerSecMatSaleMskuSuccessul(res));
              }
            })
            .catch(error => {
              // console.log("IN CATCH");
              dispatch(DemandPlannerActions.demandPlannerSecMatSaleMskuFailed(error));
            });
        })
        .catch(error => {
          // console.log("IN CATCH");
          dispatch(DemandPlannerActions.demandPlannerSecMatSaleMskuFailed(error));
        });
    };
  }

  static getDemandPlannerSecYoy(
    selectedCategory,
    selectedBrand,
    selectedSku,
  ) {
    // console.log("IS VALUEEEEE", weekFrom);
    let url = `${Path.GET_DEMAND_PLANNER_SEC_YOY}?`;

    if (selectedCategory) {
        url += `category=${selectedCategory}&`;
    }
    if (Array.isArray(selectedBrand)) {
      selectedBrand.forEach(element => {
        url += `brand=${element}&`;
      });
    }
    if (Array.isArray(selectedSku)) {
      selectedSku.forEach(element => {
        url += `master_sku=${element}&`;
      });
    }

    url = url.slice(0, -1);

    return dispatch => {
      dispatch(DemandPlannerActions.demandPlannerSecYoyRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.status === 200) {
                dispatch(DemandPlannerActions.demandPlannerSecYoySuccessul(res));
              } else {
                dispatch(DemandPlannerActions.demandPlannerSecYoyFailed('error'));
              }
            })
            .catch(error => {
              dispatch(DemandPlannerActions.demandPlannerSecYoyFailed(error));
            });
        })
        .catch(error => {
          dispatch(DemandPlannerActions.demandPlannerSecYoyFailed(error));
        });
    };
  }
}

export default DemandPlannerMiddleware;
